export const BomOptionsFormId = 'bom-options-form';
export const QuantityGroupAlertId = 'quantity-group-alert';
export const SubmitButtonIdOutsideBomOptionsForm = 'submit-button-outside-bom-options-form';
export const ContainerId = 'topbar-container-id';
export const ExitButtonId = 'exit-button-id';
export const ItemDetailDropdown = 'item-detail-dropdown';
